import React, {useEffect, useState} from 'react';
import {api} from "../api/api";
import {useLanguageStore} from "../store/languageStore";
import {Link} from "react-router-dom";


export default function SolutionsPage() {
	
	const {language} = useLanguageStore()
	const isArabic = language === 'ar'
	
	const [solutions, setSolutions] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	
	// Load currentPage from localStorage on mount
	useEffect(() => {
		const savedPage = parseInt(localStorage.getItem('currentPage')) || 1;
		setCurrentPage(savedPage);
	}, []);
	
	// Save currentPage to localStorage when it changes
	useEffect(() => {
		localStorage.setItem('currentPage', currentPage);
	}, [currentPage]);
	
	// Scroll to top on page change
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [currentPage]);
	// Solution card component
	const SolutionCard = ({product}) => (
		<Link to={`/solution/${product.id}`}>
			<div
				className={`bg-white p-4 rounded shadow hover:shadow-md transition-shadow duration-300 ${isArabic ? 'rtl text-right' : ''}`}>
				<div className="mb-4">
					<img loading="lazy"
					     src={product.image}
					     alt={product.title}
					     className="w-full   rounded"
					/>
				</div>
				<h3 className="font-bold text-lg mb-2 line-clamp-2">{isArabic ? product.title_ar : product.title_en}</h3>
				<p className="text-gray-600 text-sm line-clamp-2">{isArabic ? product.head_description_ar : product.head_description_en}</p>
			</div>
		</Link>
	);
	
	
	useEffect(() => {
		fetchSolutions(currentPage);
	}, [currentPage]);
	
	const fetchSolutions = (page) => {
		api.get(`solutions?page=${page}`)
			.then(response => {
				setSolutions(response.data.results);
				setTotalPages(Math.ceil(response.data.count / 12));
				console.log("Solutions fetched successfully!", response.data);
			})
			.catch(error => {
				console.error("There was an error fetching the solutions!", error);
			});
	};
	
	const handlePageChange = (newPage) => {
		setCurrentPage(newPage);
	};
	
	
	return (
		<div className="">
			{/* Hero Section with "SOLUTIONS" Text */}
			<div className="relative w-full mb-12">
				<img loading="lazy"
				     src={require('../assest/solutions.png')}
				     alt="Construction materials with tile installation"
				     className="w-full h-full object-cover"
				/>
				
			</div>
			
			{/* White Space Section */}
			<div className="h-20"></div>
			
			{/* Solutions Grid */}
			<div className="max-w-6xl mx-auto px-4 py-12">
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
					{solutions.map(product => (
						<SolutionCard key={product.id} product={product}/>
					))}
				</div>
				
				{/* Pagination */}
				{/* Pagination */}
				<div className="flex justify-center items-center mt-8">
					<button
						onClick={() => handlePageChange(currentPage - 1)}
						disabled={currentPage === 1}
						className={`mx-1 p-2 rounded ${
							currentPage === 1
								? 'text-gray-400 cursor-not-allowed'
								: 'text-gray-700 hover:text-teal-500'
						}`}
						aria-label={isArabic ? 'الصفحة السابقة' : 'Previous page'}
					>
						<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20"
						     fill="currentColor">
							<path fillRule="evenodd"
							      d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
							      clipRule="evenodd"/>
						</svg>
					</button>
					
					{Array.from({length: totalPages}, (_, i) => i + 1).map((page) => (
						<button
							key={page}
							onClick={() => handlePageChange(page)}
							className={`mx-1 px-3 py-1 rounded ${
								currentPage === page
									? 'bg-teal-500 text-white'
									: 'bg-gray-200 text-gray-700 hover:bg-gray-300'
							}`}
						>
							{page}
						</button>
					))}
					
					<button
						onClick={() => handlePageChange(currentPage + 1)}
						disabled={currentPage === totalPages}
						className={`mx-1 p-2 rounded ${
							currentPage === totalPages
								? 'text-gray-400 cursor-not-allowed'
								: 'text-gray-700 hover:text-teal-500'
						}`}
						aria-label={isArabic ? 'الصفحة التالية' : 'Next page'}
					>
						<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20"
						     fill="currentColor">
							<path fillRule="evenodd"
							      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
							      clipRule="evenodd"/>
						</svg>
					</button>
				</div>
			</div>
		</div>
	);
}